import React from "react";
import {
  Check,
  ChevronLeft,
  ChevronRight,
  Download,
  LogOut,
  Pencil,
  Plus,
  Save,
  Trash2,
  X,
} from "lucide-react";
import { cn } from "../../libs/utils";
import { Button } from "./button";

const actionConfig = {
  add: { label: "Add", icon: Plus, variant: "default" },
  cancel: { label: "Cancel", icon: X, variant: "outline" },
  confirm: { label: "Confirm", icon: Check, variant: "default" },
  delete: {
    label: "Delete",
    icon: Trash2,
    variant: "ghost",
    className: "text-red-600 hover:bg-red-50 hover:text-red-700",
  },
  destructive: { label: "Delete", icon: Trash2, variant: "destructive" },
  download: { label: "Download", icon: Download, variant: "ghost" },
  edit: { label: "Edit", icon: Pencil, variant: "ghost" },
  logout: { label: "Logout", icon: LogOut, variant: "default" },
  next: { label: "Next", icon: ChevronRight, variant: "outline" },
  previous: { label: "Previous", icon: ChevronLeft, variant: "outline" },
  submit: { label: "Submit", icon: Save, variant: "default" },
  update: { label: "Update", icon: Save, variant: "default" },
};

const ActionButton = React.forwardRef(function ActionButton(
  {
    action = "submit",
    label,
    icon: IconOverride,
    iconOnly = false,
    isLoading = false,
    children,
    className,
    disabled,
    variant,
    size,
    ...props
  },
  ref
) {
  const config = actionConfig[action] || actionConfig.submit;
  const Icon = IconOverride || config.icon;
  const resolvedLabel = label || config.label;
  const resolvedSize = size || (iconOnly ? "icon" : "default");

  return (
    <Button
      ref={ref}
      type="button"
      variant={variant || config.variant}
      size={resolvedSize}
      className={cn(!iconOnly && "gap-2", config.className, className)}
      disabled={disabled || isLoading}
      aria-label={iconOnly ? resolvedLabel : props["aria-label"]}
      {...props}
    >
      {Icon && <Icon className="h-4 w-4 shrink-0" />}
      {!iconOnly && <span>{isLoading ? "Please wait..." : children || resolvedLabel}</span>}
    </Button>
  );
});

export default ActionButton;
